import React from 'react'

export const About = () => {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">About</h5>
        <p className="card-text">Public website section. Keep app-specific pages under src/app.</p>
      </div>
    </div>
  )
}
